(function($) {
    $(document).ready(function() {    
        var $search = $('.search-faq');       // <-- your search input
        // var $items  = $('.details');         // <-- each FAQ row/block
        var $titles = $('.faq-question');     // <-- the question text inside each item
        var $counter = $('#faq-results-count');
        var $headers = $('.faq-header');
        var $parents = $('.section:has(.accordion)');

        // Escape regex special chars
        function escapeRegExp(str) {
            return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        }

        // Clear all highlights by resetting to plain text
        function clearHighlights() {
            $parents.each(function () {
                var $items = $parents.find('.details');
                $items.each(function () {
                    $(this)
                    .find('.details__header, .details-content') // adjust if needed
                    .each(function () {
                        var $el = $(this);
                        $el.html($el.text()); // strip any old <span class="faq-highlight">
                    });
                });
            });

            $parents.find('.details[data-faq-opened="true"]').each(function () {
                $(this).removeAttr('open').removeAttr('data-faq-opened');
            });

            $headers.show();
        }

        function countOccurrences(text, term) {
            var regex = new RegExp(escapeRegExp(term), "gi");
            var matches = text.match(regex);
            return matches ? matches.length : 0;
        }

        $search.on('input', function () {
            var term       = $.trim($(this).val());
            var termLower  = term.toLowerCase();
            var count      = 0;
            var occurrences = 0;

            clearHighlights(); // always reset first

            if (!term) {
            // Empty search: show everything, hide counter, no highlights
            $parents.show();
            $parents.find('.details').show();
            $headers.show();
            $counter.hide();
            return;
            }

            var regex = new RegExp('(' + escapeRegExp(term) + ')', 'ig');

            $parents.each(function () {
                var $parent = $(this);
                var $items = $parent.find('.details');
                var parentCount = 0;

                $items.each(function () {
                    var $item = $(this);
                    var haystack = $item.text().toLowerCase();

                    if (haystack.indexOf(termLower) === -1) {
                        // No match → hide
                        $item.hide();
                        $headers.show();
                        return;
                    }

                    // Match → show and highlight
                    $item.show();                
                    count++;
                    parentCount++;
                    $parent.show();

                    var contentText = $item.find('.details-content').text().toLowerCase();
                    if (contentText.indexOf(termLower) !== -1) {
                        $item.attr('open', true).attr('data-faq-opened', 'true');
                    }

                    $item.find('.details__header, .details-content').each(function () {
                        var $el = $(this);
                        var html = $el.html();
                        var original  = $el.text();
                        var highlighted = original.replace(regex, '<span class="faq-highlight">$1</span>');
                        $el.html(highlighted);

                        occurrences += countOccurrences(html, term);
                    });
                });

                if (parentCount == 0) {
                    $parent.hide();
                }
            });

            // Update counter
            var label =
                occurrences === 0
                    ? 'No results found.'
                    : occurrences + ' result' + (occurrences > 1 ? 's' : '') + ' found.';

            $counter.text(label).show();
            $headers.hide();
        });
    });
})(jQuery);
